export function recordNumberFromQuery(query) {
  const match = String(query ?? '').trim().match(/^(?:№|#)?\s*(\d+)$/);
  const number = match ? Number(match[1]) : NaN;
  return Number.isSafeInteger(number) && number > 0 ? number : null;
}
